import { environment } from '@environment';

export const hotelResultsApi = {
  hotel_search: `${environment.api.services}/api/travel-proxy-ms/hotel/v3/search`,
  hotel_search_byhours: `${environment.api.services}/api/travel-proxy-ms/hotel/search/micro-stay`,
  hotel_filter: `${environment.api.netactica}/Hotel/Filter/?searchId={searchId}`,
  hotel_results: `${environment.api.services}/api/travel-proxy-ms/hotel/results`,
  hotel_search_location: `${environment.api.travel_static_content}/location/iatacode?` +
    'iatacode={code}'
};
